import React, { useEffect, useState } from "react";
import {
    HeroSection,
    VideoEvolutionSection,
    PositioningSection,
    WhatIsSection,
    FeaturesSection,
    BonusSection,
} from "./landing/SectionsTop";
import {
    CommunitySection,
    TestimonialsSection,
    ContrastPainSection,
    WorkflowTimelineSection,
    OfferSection,
    StepsSection,
    WrapUpSection,
    FAQSection,
    Footer,
} from "./landing/SectionsBottom";
import { trackAndRedirect, initTracking } from "../lib/track";
import { ArrowRight, Bell } from "lucide-react";

function StickyMobileCTA({ visible }) {
    if (!visible) return null;
    return (
        <div
            data-testid="sticky-mobile-cta"
            className="fixed bottom-0 left-0 right-0 z-50 md:hidden p-3 bg-[#0a0d14]/95 backdrop-blur border-t border-white/10"
        >
            <button
                onClick={() =>
                    trackAndRedirect("mobile-sticky", {
                        label: "Start 5-Day Trial",
                        section: "sticky-mobile",
                    })
                }
                data-testid="cta-mobile-sticky"
                className="btn-primary w-full justify-center !py-3"
            >
                <Bell className="w-4 h-4" />
                Start 5-Day Trial
                <ArrowRight className="w-4 h-4" />
            </button>
        </div>
    );
}

function FloatingDesktopCTA({ visible }) {
    if (!visible) return null;
    return (
        <div
            data-testid="floating-desktop-cta"
            className="fixed bottom-8 right-8 z-50 hidden md:block fade-in-up"
        >
            <button
                onClick={() =>
                    trackAndRedirect("desktop-floating", {
                        label: "Start 5-Day Trial",
                        section: "floating-desktop",
                    })
                }
                data-testid="cta-desktop-floating"
                className="btn-primary gold-glow !py-3.5 !px-6 text-sm"
            >
                <Bell className="w-4 h-4" />
                Start 5-Day Trial
            </button>
        </div>
    );
}

export default function Landing() {
    const [showFloating, setShowFloating] = useState(false);
    useEffect(() => {
        const cleanup = initTracking();
        const onScroll = () => setShowFloating(window.scrollY > 800);
        window.addEventListener("scroll", onScroll, { passive: true });
        onScroll();
        return () => {
            window.removeEventListener("scroll", onScroll);
            if (typeof cleanup === "function") cleanup();
        };
    }, []);

    return (
        <main className="bg-white text-[var(--mbe-text-light)]">
            <HeroSection />
            <VideoEvolutionSection />
            <PositioningSection />
            <WhatIsSection />
            <FeaturesSection />
            <BonusSection />
            <CommunitySection />
            <TestimonialsSection />
            <ContrastPainSection />
            <WorkflowTimelineSection />
            <OfferSection />
            <StepsSection />
            <WrapUpSection />
            <FAQSection />
            <Footer />

            <StickyMobileCTA visible={true} />
            <FloatingDesktopCTA visible={showFloating} />
            <div className="md:hidden h-16" /> {/* spacer for sticky mobile CTA */}
        </main>
    );
}
